<div>
    <aum-search placeholder="search" floatLabel="always" (search)="applyFilter($event)"> </aum-search>
</div>
<div>
    <table class="table table-sm table-bordered">
        <thead>
            <tr>
                <th scope="col"></th>
                <th scope="col">{{'aumico_admin_ar_template_general_information_name' | i18next }}</th>
            </tr>
        </thead>
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
            <tr cdkDrag cdkDragLockAxis="y" *ngFor="let data of tableData">
                <td *ngIf="!searchValue || data.name.toLowerCase().includes(searchValue.toLowerCase())">
                    <mat-checkbox (change)="handleSelection(data)" class="custom-checkbox" [checked]="data.selected">
                    </mat-checkbox>
                </td>
                <td *ngIf="!searchValue || data.name.toLowerCase().includes(searchValue.toLowerCase())">
                    {{data.name}}
                </td>

                <div *cdkDragPreview class="container dragdrop-placeholder">{{data.name}}</div>
            </tr>
        </tbody>
    </table>
</div>
